import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import { getWindow } from '@ps/web-core-utils';
import React from 'react';

import Prompt from '../../Prompt/Prompt';

import { TXTWCL_Document_preview } from './DocumentsPreview.messages.json';
import { content, documentsPreviewWrapper } from './DocumentsPreview.scss';

interface Props {
  acceptedFile: File;
  allFiles: File[];
  onClose: () => void;
}

const DocumentsPreview: React.FC<Props> = ({ acceptedFile, allFiles, onClose }) => {
  const allAceptedDocuments = allFiles.map((file) => ({
    uri: getWindow()?.URL.createObjectURL(file) ?? '',
    fileName: file.name
  }));
  const selectedDocumentIndex = allAceptedDocuments.findIndex(
    (name) => name.fileName === acceptedFile.name
  );

  return (
    <Prompt
      classes={{ content }}
      title={{ translation: { ...TXTWCL_Document_preview } }}
      variant="info"
      onClose={onClose}
    >
      <DocViewer
        className={documentsPreviewWrapper}
        documents={allAceptedDocuments}
        initialActiveDocument={allAceptedDocuments[selectedDocumentIndex]}
        pluginRenderers={DocViewerRenderers}
        config={{
          loadingRenderer: {
            showLoadingTimeout: false
          },
          header: {
            disableHeader: false,
            disableFileName: false,
            retainURLParams: false
          }
        }}
      />
    </Prompt>
  );
};

export default DocumentsPreview;
